import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import GridItem from 'src/components/grid-item/GridItem'
import { BusinessJudgementFilingsReport } from 'src/modules/serasa/serasa.experian.business.types'
import { formatDateNoTz } from 'src/utils/formatter-utils'

export type AcaoJudicialProps = {
    acaoJudicial: BusinessJudgementFilingsReport
}

export default function AcaoJudicial({ acaoJudicial }: AcaoJudicialProps) {
    return (
        <>
            <Divider textAlign="center">Ação Judicial</Divider>
            {acaoJudicial && (
                <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                    <GridItem label="Total Ocorrências" value={acaoJudicial.summary.count.toFixed(0)} xs={6} />
                    <GridItem label="Total Valores" value={acaoJudicial.summary.balance.toFixed(2)} xs={6} />

                    {acaoJudicial.judgementFilingsResponse?.map((ocorrencia, index) => (
                        <Grid key={index} container spacing={1}>
                            <GridItem label="Data" value={formatDateNoTz(ocorrencia.occurrenceDate)} xs={6} />
                            <GridItem label="Natureza" value={ocorrencia.legalNature} xs={6} />
                            <GridItem label="Valor" value={ocorrencia.amount.toFixed(2)} xs={6} />
                            <GridItem label="Distância" value={ocorrencia.distributor} xs={6} />
                            <GridItem label="Vara" value={ocorrencia.civilCourt} xs={6} />
                            <GridItem label="Cidade" value={ocorrencia.city || '-'} xs={6} />
                            <GridItem label="UF" value={ocorrencia.state || '-'} xs={6} />
                        </Grid>
                    ))}
                </Grid>
            )}
        </>
    )
}
